export default "__VITE_ASSET__BSbZ5vu5__"